exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sw-mv-content .sw-mv-content-wrapper .sw-mv-content-body{padding:16px 24px 32px}", ""]);
